import { useState, useEffect } from "react";
import SunEditor from "suneditor-react";
import "suneditor/dist/css/suneditor.min.css";
import { BASE_IMAGE_URL } from "../../../services/apiService";
import productService from "../../../services/productService";
import Swal from "sweetalert2";
 export default function CrudForm({
  initialData = {},
  onSubmit,
  categories = [],
  blogCategories = [],
  subCategories = [],
  childCategories = [],
  brands = [],
  sizeOptions = [],
  colorOptions = [],
  unitOptions = [],
  products = [],
  allowedFields = [],
  fileFields = [],
  customFields = {},
  fileUploadStyle = "default",
  variants = [],
  onVariantsChange = () => {},
   showVariants = false,
}) {
  const [form, setForm] = useState({});
  const [formErrors, setFormErrors] = useState({});
  const [previewUrls, setPreviewUrls] = useState({});
  const [formInitialized, setFormInitialized] = useState(false);
  const [colors, setColors] = useState([]);
  const [showProductDropdown, setShowProductDropdown] = useState(false);
 const colorMap = {
  Red: "#FF0000",
  Orange: "#FFA500",
  Green: "#008000",
  Blue: "#0000FF",
  Purple: "#800080",
  Pink: "#FFC0CB",
  Brown: "#A52A2A",
  White: "#FFFFFF",
  Gray: "#808080",
  Black: "#000000",
  Golden: "#FFD700",
  Silver: "#C0C0C0",
  Yellow: "#FFFF00",
  "Mint Green": "#98FF98",
  "Mint Pink": "#FFD1DC",
};                                                                                                


  //   useEffect(() => {
  //   if (initialData && !formInitialized) {
  //     const normalizedData = {
  //       ...initialData,
  //       status:
  //         initialData.status === true || initialData.status === "true"
  //           ? 1
  //           : initialData.status === false || initialData.status === "false"
  //           ? 0
  //           : Number(initialData.status ?? 0),
  //     };

  //     setForm(normalizedData);
  //     setFormInitialized(true);
  //     setPreviewUrls({});
  //   }
  // }, [initialData, formInitialized]);

useEffect(() => {
  if (initialData && !formInitialized) {

    const normalizedData = {
      ...initialData,
      status:
        initialData.status === true || initialData.status === "true"
          ? 1
          : initialData.status === false || initialData.status === "false"
            ? 0
            : Number(initialData.status ?? 0),

      products: initialData.products || [],

      // ✅ FIX HERE: always normalize colors properly
     colors: Array.isArray(initialData.colors)
  ? initialData.colors.map((c) => {
      const code =
        typeof c === "string"
          ? c
          : c.code || c.color_code || "";

      const matchedName =
        Object.keys(colorMap).find(
          (key) =>
            colorMap[key].toLowerCase() === code.toLowerCase()
        ) || "";

      return {
        name: c.name || matchedName,
        code,
      };
    })
  : [],
    };

    const previews = {};

    // multiple images
    if (initialData.images && Array.isArray(initialData.images)) {
      previews.images = initialData.images.map((img) => {
        return BASE_IMAGE_URL + (img.image || img);
      });
    }

    if (initialData.cat_image) {
      previews.cat_image = BASE_IMAGE_URL + initialData.cat_image;
    }
if (initialData.sub_cat_image) {
  previews.sub_cat_image =
    BASE_IMAGE_URL + initialData.sub_cat_image;
}
    setForm(normalizedData);
    setPreviewUrls(previews);
    setFormInitialized(true);
  }
}, [initialData, formInitialized]);

  console.log("initial images", initialData.images)

  useEffect(() => {
    return () => {
      Object.values(previewUrls).forEach((urls) => {
        if (Array.isArray(urls)) {
          urls.forEach((url) => url && URL.revokeObjectURL(url));
        } else if (urls) {
          URL.revokeObjectURL(urls);
        }
      });
    };
  }, [previewUrls]);

  const isFileField = (field) => {
    return fileFields.some((f) => f.name === field);
  };

  const isMultipleField = (field) => {
    const f = fileFields.find((f) => f.name === field);
    return f ? !!f.multiple : false;
  };

  const handleChange = (e) => {
    const { name, type, value, files } = e.target;
    console.log("INPUT CHANGE:", name, type, files);
    if (type === "file" && isFileField(name)) {
      const multiple = isMultipleField(name);
      const selectedFiles = multiple ? Array.from(files) : [files[0]];

      setForm((prev) => {

        const existing = Array.isArray(prev[name])
          ? prev[name]
          : prev[name]
            ? [prev[name]]
            : [];

        const updatedImages = multiple
          ? [...existing, ...selectedFiles]
          : selectedFiles[0];

        console.log("UPDATED IMAGES:", updatedImages); // ✅ NOW SAFE

        return {
          ...prev,
          [name]: updatedImages,
        };
      });

      setPreviewUrls((prev) => {
        const existingUrls = Array.isArray(prev[name]) ? prev[name] : [];
        const newUrls = selectedFiles.map((file) => URL.createObjectURL(file));

        return {
          ...prev,
          [name]: multiple ? [...existingUrls, ...newUrls] : newUrls[0],
        };
      });

      e.target.value = null;
    } else {
      setForm((prev) => ({
        ...prev,
        [name]: value,
      }));
    }
  };


  //   const handleChange = (e) => {
  //     const { name, type, value, files } = e.target;

  //     const fieldConfig = customFields?.[name];

  //     if (fieldConfig?.readOnly || fieldConfig?.disabled) {
  //       return; // ⛔ skip updates
  //     }


  //     if (type === "file" && isFileField(name)) {
  //       const multiple = isMultipleField(name);

  //       let selectedFiles = multiple ? Array.from(files) : files[0] ? [files[0]] : [];

  //       let errors = "";

  //       // Validate files one by one
  //       selectedFiles.forEach((file) => {
  //         const validTypes = ["image/jpeg", "image/png", "image/gif"];
  //         const maxSizeMB = 5;
  //         if (!validTypes.includes(file.type)) {
  //           errors = `${formatLabel(name)} must be JPEG, PNG, or GIF images.`;
  //         } else if (file.size > maxSizeMB * 1024 * 1024) {
  //           errors = `${formatLabel(name)} must be less than ${maxSizeMB}MB.`;
  //         }
  //       });

  //       if (!multiple && selectedFiles.length === 0 && fileFields.find(f => f.name === name)) {
  //         errors = `${formatLabel(name)} is required.`;
  //       }

  //       setForm((prev) => ({
  //         ...prev,
  //         [name]: multiple ? selectedFiles : selectedFiles[0] || null,
  //       }));

  //       setFormErrors((prev) => ({
  //         ...prev,
  //         [name]: errors,
  //       }));

  //       // Revoke old URLs for this field
  //       setPreviewUrls((prev) => {
  //         if (prev[name]) {
  //           if (Array.isArray(prev[name])) {
  //             prev[name].forEach((url) => url && URL.revokeObjectURL(url));
  //           } else {
  //             prev[name] && URL.revokeObjectURL(prev[name]);
  //           }
  //         }
  //         return {
  //           ...prev,
  //           [name]: multiple
  //             ? selectedFiles.map((file) => URL.createObjectURL(file))
  //             : selectedFiles[0]
  //               ? URL.createObjectURL(selectedFiles[0])
  //               : null,
  //         };
  //       });
  //     } else {
  //   setForm((prev) => ({
  //     ...prev,
  //     [name]:
  //       name === "status"
  //         ? Number(value)
  //         : name === "offer_start_date" ||
  //           name === "offer_end_date" ||
  //           name === "start_date" ||
  //           name === "end_date"
  //         ? value && value !== "" // ✅ convert empty string to null
  //           ? value
  //           : null
  //         : value,
  //   }));
  // }

  //   };

  const handleClearFile = (field) => {
    const multiple = isMultipleField(field);

    setForm((prev) => ({
      ...prev,
      [field]: multiple ? [] : null,
    }));

    setPreviewUrls((prev) => {
      if (prev[field]) {
        if (Array.isArray(prev[field])) {
          prev[field].forEach((url) => url && URL.revokeObjectURL(url));
        } else {
          prev[field] && URL.revokeObjectURL(prev[field]);
        }
      }
      return {
        ...prev,
        [field]: multiple ? [] : null,
      };
    });

    setFormErrors((prev) => ({
      ...prev,
      [field]: fileFields.some((f) => f.name === field) ? `${formatLabel(field)} is required.` : "",
    }));
  };


 const handleRemoveFileAtIndex = async (field, index) => {
  const imageItem = form[field]?.[index];

  try {
    // Existing image from database
    if (imageItem?.existing && imageItem?.id) {
      await productService.deleteProductImage(imageItem.id);

      Swal.fire({
        icon: "success",
        title: "Deleted",
        text: "Image deleted successfully",
        timer: 1500,
        showConfirmButton: false,
      });
    }

    const updatedFiles = Array.isArray(form[field])
      ? [...form[field]]
      : [];

    const updatedUrls = Array.isArray(previewUrls[field])
      ? [...previewUrls[field]]
      : [];

    updatedFiles.splice(index, 1);
    updatedUrls.splice(index, 1);

    setForm((prev) => ({
      ...prev,
      [field]: updatedFiles,
    }));

    setPreviewUrls((prev) => ({
      ...prev,
      [field]: updatedUrls,
    }));
  } catch (error) {
    console.error(error);

    Swal.fire({
      icon: "error",
      title: "Error",
      text: "Failed to delete image",
    });
  }
};

  const handleEditorChange = (field, content) => {
    setForm((prev) => ({
      ...prev,
      [field]: content,
    }));
  };

  // const handleSubmit = (e) => {
  //   e.preventDefault();

  //   const errors = {};
  //   fileFields.forEach(({ name }) => {
  //     if (allowedFields.includes(name) && (!form[name] || (Array.isArray(form[name]) && form[name].length === 0))) {
  //       errors[name] = `${formatLabel(name)} is required`;
  //     }
  //   });

  //   setFormErrors(errors);

  //   if (Object.keys(errors).length === 0 && !Object.values(formErrors).some((err) => err)) {
  //     onSubmit(form);
  //   }
  // };


  const handleSubmit = (e) => {
    e.preventDefault();

    const errors = {};

    // Validate required file fields
   fileFields.forEach(({ name, required = true }) => {
  if (
    required &&
    allowedFields.includes(name) &&
    (
      !form[name] ||
      (Array.isArray(form[name]) && form[name].length === 0)
    )
  ) {
    errors[name] = `${formatLabel(name)} is required`;
  }
});


    ["offer_start_date", "offer_end_date", "start_date", "end_date"].forEach((dateField) => {
      if (!form[dateField]) {
        delete errors[dateField];
      }
    });

    setFormErrors(errors);

    // Only submit if there are no errors
    if (Object.keys(errors).length === 0) {
      onSubmit(form);
    }
  };



  const formatLabel = (field) => {
    if (field === "category_id") return "Category";
    if (field === "sub_category_id") return "Sub Category";
    if (field === "child_category_id") return "Child Category";
    if (field === "cat_image") return "Category Image";
    return field.charAt(0).toUpperCase() + field.slice(1).replace(/_/g, " ");
  };
  console.log("FORM STATE:", form);
  console.log("PREVIEW URLS:", previewUrls);
  console.log("FILE UPLOAD STYLE:", fileUploadStyle);
  return (
  <form
  onSubmit={handleSubmit}
  style={{
    width: "100%",
    maxWidth: "none",
    marginLeft: 0,
    marginRight: 0,
  }}
>
      {Object.keys(form)
        .filter((field) => allowedFields.length === 0 || allowedFields.includes(field))
        .map((field) =>
          field !== "id" && field !== "colors" ? (
            <div className="mb-3 " key={field}>
            
<label htmlFor={field} className="form-label">
  {formatLabel(field)}

  {fileFields.some((f) => f.name === field) && (
    <span className="text-danger ms-1">*</span>
  )}
</label>



              {/* Handling selects */}
              {field === "product_type" ? (
                <select
                  id={field}
                  name={field}
                  value={form[field] ?? ""}
                  onChange={handleChange}
                  className="form-control"
                >
                  <option value="">Select Product Type</option>
                  <option value="new_product">New Product</option>
                  <option value="featured_product">Featured Product</option>
                  <option value="new_arrival">New Arrival</option>
                  <option value="best_seller">Best Seller</option>
                  <option value="top_rated">Top Rated</option>
                  <option value="special_offer">Special Offer</option>
                </select>
              )

                : field === "category_id" ? (
                  <select
                    id={field}
                    name={field}
                    value={form[field] || ""}
                    onChange={handleChange}
                    className="form-control"
                  >
                    <option value="">Select Category</option>
                    {categories.map((cat) => (
                      <option key={cat.id} value={cat.id}>
                        {cat.name}
                      </option>
                    ))}
                    {blogCategories.map((blogcat) => (
                      <option key={blogcat.id} value={blogcat.id}>
                        {blogcat.name}
                      </option>
                    ))}
                  </select>
                ) : field === "sub_category_id" ? (
                  <select
                    id={field}
                    name={field}
                    value={form[field] || ""}
                    onChange={handleChange}
                    className="form-control"
                  >
                    <option value="">Select Sub Category</option>
                    {subCategories
                      .filter((sub) => !form.category_id || sub.category_id === Number(form.category_id))
                      .map((sub) => (
                        <option key={sub.id} value={sub.id}>
                          {sub.name}
                        </option>
                      ))}
                  </select>
                ) : field === "child_category_id" ? (
                  <select
                    id={field}
                    name={field}
                    value={form[field] || ""}
                    onChange={handleChange}
                    className="form-control"
                  >
                    <option value=""> Select Child Category </option>
                    {childCategories
                      .filter((child) => !form.sub_category_id || child.sub_category_id === Number(form.sub_category_id))
                      .map((child) => (
                        <option key={child.id} value={child.id}>
                          {child.name}
                        </option>
                      ))}
                  </select>
                ) : field === "products" ? (
                  <div className="mb-3">


                    {/* Selected Products */}
                    <div
                      style={{
                        border: "1px solid #ddd",
                        borderRadius: "6px",
                        padding: "10px",
                        minHeight: "45px",
                        background: "#fff",
                      }}
                    >
                      {(form.products || []).length === 0 ? (
                        <span style={{ color: "#aaa", fontSize: "14px" }}>
                          No products added
                        </span>
                      ) : (
                        (form.products || []).map((product) => {

                          return (
                            <span
                              key={product.id}
                              style={{
                                display: "inline-flex",
                                alignItems: "center",
                                gap: "6px",
                                border: "1px solid #ccc",
                                padding: "4px 10px",
                                borderRadius: "4px",
                                marginRight: "6px",
                                marginBottom: "6px",
                                fontSize: "13px",
                                background: "#f5f5f5",
                              }}
                            >
                              <img
                                src={
                                  product.thumb_image
                                    ? BASE_IMAGE_URL + product.thumb_image
                                    : "/no-image.png"
                                }
                                alt={product.name}
                                style={{
                                  width: "25px",
                                  height: "25px",
                                  objectFit: "cover",
                                  borderRadius: "3px",
                                }}
                              />

                              {product.name}

                              <button
                                type="button"
                                onClick={() => {
                                  const updated = form.products.filter((p) => p.id !== product.id);
                                  setForm({ ...form, products: updated });
                                }}
                                style={{
                                  marginLeft: "6px",
                                  border: "none",
                                  background: "transparent",
                                  cursor: "pointer",
                                }}
                              >
                                ✕
                              </button>
                            </span>
                          );
                        })
                      )}
                    </div>

                    {/* ADD BUTTON */}
                    <button
                      type="button"
                      className="btn btn-sm btn-outline-primary mt-2"
                      onClick={() => setShowProductDropdown(true)}
                    >
                      + Add Product
                    </button>

                    {/* DROPDOWN (SHOW ONLY WHEN CLICKED) */}
                    {showProductDropdown && (
                      <div
                        style={{
                          border: "1px solid #ddd",
                          borderRadius: "6px",
                          maxHeight: "200px",
                          overflowY: "auto",
                          marginTop: "10px",
                          maxWidth: "800px",
                          background: "#fff"
                        }}
                      >
                        {products
                          .filter((p) => !form.products?.some((fp) => fp.id === p.id))// ✅ HIDE selected products
                          .map((p) => {
                            return (
                              <div
                                key={p.id}
                                onClick={() => {
                                  if (!form.products?.some((fp) => fp.id === p.id)) {
                                    setForm({
                                      ...form,
                                      products: [...(form.products || []), p],
                                    });
                                  }

                                  setShowProductDropdown(false);
                                }}
                                style={{
                                  display: "flex",
                                  alignItems: "center",
                                  gap: "10px",
                                  padding: "8px",
                                  cursor: "pointer",
                                  borderBottom: "1px solid #eee",
                                  background: "#fff"
                                }}
                              >

                                {/* ✅ PRODUCT IMAGE */}
                                <img
                                  src={p.thumb_image ? BASE_IMAGE_URL + p.thumb_image : "/no-image.png"}
                                  alt={p.name}
                                  style={{
                                    width: "40px",
                                    height: "40px",
                                    objectFit: "cover",
                                    borderRadius: "4px"
                                  }}
                                />


                                {/* ✅ PRODUCT NAME */}
                                <span style={{ fontSize: "14px" }}>{p.name}</span>
                              </div>
                            );
                          })}
                      </div>
                    )}
                  </div>
                )
                 
: field === "brand_id" ? (
  <select
    id={field}
    name={field}
    value={form[field] ?? ""}
    onChange={handleChange}
    className="form-control"
  >
    <option value="">-- Select Brand --</option>

    {brands.map((brand) => (
      <option key={brand.id} value={brand.id}>
        {brand.name}
      </option>
    ))}
  </select>
)
: field === "status" || field === "is_approved" || field === "is_featured" ? (
                    <select
                      id={field}
                      name={field}
                      value={form[field] ?? 0}

                      onChange={(e) =>
                        setForm({
                          ...form,
                          [field]: Number(e.target.value),
                        })
                      }
                      className="form-control"
                    >
                      <option value={1}>Active</option>
                      <option value={0}>Inactive</option>
                    </select>

                  ) : field === "is_default" ? (
                    <select
                      id={field}
                      name={field}
                      value={form[field]}
                      onChange={handleChange}
                      className="form-control"
                    >
                      <option value={1}>Yes</option>
                      <option value={0}>No</option>
                    </select>
                  ) :

                    field === "type" ? (
                      <select
                        id={field}
                        name={field}
                        value={form[field] || ""}
                        onChange={handleChange}
                        className="form-control"
                      >

                        <option value="flat_cost">Flat Cost</option>
                        <option value="min_cost">Min Order Amount</option>


                      </select>
                    ) :

                      field === "discount_type" ? (
                        <select
                          id={field}
                          name={field}
                          value={form[field] || ""}
                          onChange={handleChange}
                          className="form-control"
                        >
                          <option value="percentage">Percentage (%)</option>
                          <option value="amount">Amount (Rs)</option>
                        </select>
                      ) :
                        field === "user_role" ? (
                          <select
                            id={field}
                            name={field}
                            value={form[field] || ""}
                            onChange={handleChange}
                            className={`form-control ${customFields?.[field]?.className || ""}`}
                            disabled={customFields?.[field]?.disabled || false}
                          >
                            <option value="user">User</option>
                            <option value="vendor">Vendor</option>
                            <option value="admin">Admin</option>
                          </select>
                        )


                          : field === "offer_start_date" || field === "offer_end_date" || field === "start_date" || field === "end_date" ? (
                            <input
                              type="date"
                              id={field}
                              name={field}
                              value={form[field] || ""}
                              onChange={handleChange}
                              className="form-control"
                            />
                          ) : isFileField(field) ? (
                            fileUploadStyle === "product" ? (

                              <div
                                style={{
                                  border: "1px solid #d8d8d8",
                                  padding: "20px",
                                  borderRadius: "6px",
                                  // background: "#851414"
                                }}
                              >

                                <label
                                  style={{
                                    background: "#3b82f6",
                                    color: "white",
                                    padding: "8px 18px",
                                    borderRadius: "4px",
                                    fontWeight: "600",
                                    cursor: "pointer",
                                    display: "inline-block"
                                  }}
                                >
                                  Browse Files
                                  <input
                                    id={field}
                                    name={field}
                                    type="file"
                                    multiple={isMultipleField(field)}
                                    onChange={handleChange}
                                    accept="image/jpeg,image/png,image/gif"
                                    hidden
                                  />
                                </label>

                                {Array.isArray(previewUrls[field]) && (
                                  <p
                                    style={{
                                      marginTop: "10px",
                                      fontSize: "14px",
                                      color: "#777"
                                    }}
                                  >
                                    Uploaded Files ({previewUrls[field].length})
                                  </p>
                                )}

                                <div style={{ marginTop: "15px" }}>

                                  {/* MULTIPLE IMAGES (gallery) */}
                                  {Array.isArray(previewUrls[field]) &&
                                    previewUrls[field].map((url, index) => {
                                      const file = form[field]?.[index];

                                      return (
                                        <div
                                          key={url}
                                          style={{
                                            display: "flex",
                                            alignItems: "center",
                                            gap: "15px",
                                            border: "1px solid #e6e6e6",
                                            padding: "10px",
                                            marginBottom: "10px",
                                            borderRadius: "6px",
                                            background: "#fff"
                                          }}
                                        >
                                          <img
                                            src={url}
                                            alt="preview"
                                            style={{
                                              width: "60px",
                                              height: "60px",
                                              objectFit: "cover",
                                              borderRadius: "4px"
                                            }}
                                          />

                                          <div style={{ flex: 1 }}>
                                            <span style={{ fontSize: "14px" }}>
                                              {typeof file === "string"
                                                ? file.split("/").pop()
                                                : file?.name || `Image ${index + 1}`}
                                            </span>
                                          </div>

                                          <button
                                            type="button"
                                            onClick={() => handleRemoveFileAtIndex(field, index)}
                                            style={{
                                              border: "none",
                                              background: "#f1f1f1",
                                              width: "28px",
                                              height: "28px",
                                              borderRadius: "4px",
                                              cursor: "pointer"
                                            }}
                                          >
                                            ✕
                                          </button>
                                        </div>
                                      );
                                    })}

                                  {/* SINGLE IMAGE (thumb_image) */}
                                  {!Array.isArray(previewUrls[field]) && previewUrls[field] && (
                                    <div
                                      style={{
                                        display: "flex",
                                        alignItems: "center",
                                        gap: "15px",
                                        border: "1px solid #e6e6e6",
                                        padding: "10px",
                                        marginBottom: "10px",
                                        borderRadius: "6px",
                                        background: "#fff"
                                      }}
                                    >
                                      <img
                                        src={previewUrls[field]}
                                        alt="preview"
                                        style={{
                                          width: "60px",
                                          height: "60px",
                                          objectFit: "cover",
                                          borderRadius: "4px"
                                        }}
                                      />

                                      <button
                                        type="button"
                                        onClick={() => handleClearFile(field)}
                                        style={{
                                          border: "none",
                                          background: "#f1f1f1",
                                          width: "28px",
                                          height: "28px",
                                          borderRadius: "4px",
                                          cursor: "pointer"
                                        }}
                                      >
                                        ✕
                                      </button>
                                    </div>
                                  )}

                                </div>

                                {formErrors[field] && (
                                  <div className="text-danger mt-1">{formErrors[field]}</div>
                                )}
                              </div>

                            ) : (

                              <>
                                <input
                                  type="file"
                                  id={field}
                                  name={field}
                                  multiple={isMultipleField(field)}
                                  onChange={handleChange}
                                  accept="image/jpeg,image/png,image/gif"
                                  className="form-control"
                                />

                                {previewUrls[field] && (
                                  <div style={{ marginTop: "10px" }}>

                                    {Array.isArray(previewUrls[field]) ? (
                                      previewUrls[field].map((url, index) => (
                                        <img
                                          key={index}
                                          src={url}
                                          alt="preview"
                                          style={{
                                            width: "70px",
                                            height: "70px",
                                            objectFit: "cover",
                                            marginRight: "10px",
                                            borderRadius: "4px"
                                          }}
                                        />
                                      ))
                                    ) : (
                                      <img
                                        src={previewUrls[field]}
                                        alt="preview"
                                        style={{
                                          width: "70px",
                                          height: "70px",
                                          objectFit: "cover",
                                          borderRadius: "4px"
                                        }}
                                      />
                                    )}

                                  </div>
                                )}

                              </>
                            )
                          )



                            : field === "description" || field === "long_description" ? (
                              <SunEditor
                                defaultValue={form[field] || ""}
                                onChange={(content) => handleEditorChange(field, content)}
                                height="400px"
                                setOptions={{
                                  buttonList: [
                                    ["undo", "redo"],
                                    ["font", "fontSize", "formatBlock"],
                                    ["paragraphStyle", "blockquote"],
                                    [
                                      "bold",
                                      "underline",
                                      "italic",
                                      "strike",
                                      "subscript",
                                      "superscript",
                                    ],
                                    ["fontColor", "hiliteColor", "textStyle"],
                                    ["removeFormat"],
                                    ["outdent", "indent"],
                                    ["align", "horizontalRule", "list", "lineHeight"],
                                    ["table"],
                                    ["link"],
                                    ["fullScreen", "showBlocks", "codeView"],
                                    ["preview", "print"],
                                  ],
                                }}
                                contentStyle={`
                    column-count: 2;
                    column-gap: 40px;
                    padding: 10px;
                    font-family: Georgia, serif;
                  `}
                              />
                            ) : field === "seo_description" || field === "seo_keywords" ? (
                              <textarea
                                id={field}
                                name={field}
                                value={form[field] || ""}
                                onChange={handleChange}
                                placeholder={formatLabel(field)}
                                className="form-control"
                                rows={4}
                              />
                            ) : (
                              <input
                                id={field}
                                name={field}
                                value={form[field] || ""}
                                onChange={handleChange}
                                placeholder={formatLabel(field)}
                                className="form-control"
                              />
                            )}
            </div>
          ) : null
        )}
        
{/* PRODUCT VARIANTS */}
 {/* PRODUCT VARIANTS */}
{showVariants && typeof onVariantsChange === "function" && (
  <div className="mb-4">
    {/* Heading + Add Variant Button */}
    <div
      style={{
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        marginBottom: "14px",
        paddingBottom: "12px",
        borderBottom: "1px solid #ddd",
        gap: "12px",
      }}
    >
      <h4
        style={{
          fontSize: "19px",
          fontWeight: 600,
          margin: 0,
        }}
      >
        Product Variants
      </h4>

      <button
        type="button"
        className="btn " 
       
        onClick={() =>
          onVariantsChange([
            ...variants,
            {
              variant_size: "",
              // color_name: "",
              unit: "",
              variant_sku: "",
              variant_price: "",
              variant_offer_price: "",
              variant_qty: "",
            },
          ])
        }
        style={{
          fontWeight: 600,
          padding: "7px 14px",
          whiteSpace: "nowrap",
         backgroundColor:" #3b82f6",
         color:"white"
        }}
      >
        + Add Variant
      </button>
    </div>

    {/* Variants Table */}
    <div
      style={{
        width: "100%",
        maxWidth: "100%",
        overflowX: "auto",
      }}
    >
      {/* Keep your existing table here, unchanged */}
      <table
        className="table table-bordered align-middle"
        style={{
          width: "100%",
          minWidth: "900px",
          marginBottom: "20px",
          tableLayout: "auto",
          whiteSpace: "nowrap",
        }}
      >
       <thead>
  <tr style={{ background: "#f1f1f1" }}>
    {[
      { label: "SIZE", required: true },
      // { label: "COLOR", required: true },
      { label: "UNIT", required: false },
      { label: "SKU", required: true },
      { label: "PRICE", required: true },
      { label: "OFFER PRICE", required: false },
      { label: "QUANTITY", required: true },
      { label: "ACTION", required: false },
    ].map((heading) => (
      <th
        key={heading.label}
        style={{
          textAlign: "center",
          verticalAlign: "middle",
          background: "#f1f1f1",
          whiteSpace: "nowrap",
          padding: "12px 8px",
        }}
      >
        {heading.label}
        {heading.required && (
          <span
            style={{
              color: "red",
              marginLeft: "4px",
              fontWeight: "bold",
            }}
          >
            *
          </span>
        )}
      </th>
    ))}
  </tr>
</thead>



      <tbody>
  {variants.map((variant, index) => { 
    console.log("CrudForm variants prop:", variants);
console.log("Current variant row:", variant);
    const updateVariant = (field, value) => {
      onVariantsChange(
        variants.map((item, i) =>
          i === index ? { ...item, [field]: value } : item
        )
      );
    };



    return (
      <tr key={index}>
        {/* SIZE */}
       {/* SIZE */}
{/* SIZE */}
<td style={{ minWidth: "150px" }}>
<input
  type="text"
  value={variant.variant_size ?? ""}
  onChange={(e) => updateVariant("variant_size", e.target.value)}
  className="form-control"
  placeholder="Enter Size"
/>
</td>

{/* UNIT */}
<td style={{ minWidth: "150px" }}>
 <input
  type="text"
  value={variant.unit ?? ""}
  onChange={(e) => updateVariant("unit", e.target.value)}
  className="form-control"
  placeholder="Enter Unit"
/>
</td>

        {/* SKU */}
        <td style={{ minWidth: "130px" }}>
          <input
            className="form-control"
            placeholder="SKU"
            value={variant.variant_sku || ""}
            onChange={(e) => updateVariant("variant_sku", e.target.value)}
            required
          />
        </td>

        {/* PRICE */}
        <td style={{ minWidth: "130px" }}>
          <input
            type="number"
            className="form-control"
            placeholder="Price"
            min="0"
            step="0.01"
            value={variant.variant_price || ""}
            onChange={(e) => updateVariant("variant_price", e.target.value)}
            required
          />
        </td>

        {/* OFFER PRICE */}
        <td style={{ minWidth: "130px" }}>
          <input
            type="number"
            className="form-control"
            placeholder="Offer Price"
            min="0"
            step="0.01"
            value={variant.variant_offer_price || ""}
            onChange={(e) =>
              updateVariant("variant_offer_price", e.target.value)
            }
          />
        </td>

        {/* QUANTITY */}
        <td style={{ minWidth: "130px" }}>
          <input
            type="number"
            className="form-control"
            placeholder="Quantity"
            min="0"
            step="1"
            value={variant.variant_qty || ""}
            onChange={(e) => updateVariant("variant_qty", e.target.value)}
            required
          />
        </td>

        {/* ACTION */}
        <td style={{ textAlign: "center", minWidth: "100px" }}>
          <button
            type="button"
            className="btn btn-danger"
            title="Delete variant"
            onClick={() => {
              onVariantsChange(
                variants.length === 1
                  ? [
                      {
                        variant_size: "",
                        unit: "",
                        variant_sku: "",
                        variant_price: "",
                        variant_offer_price: "",
                        variant_qty: "",
                      },
                    ]
                  : variants.filter((_, i) => i !== index)
              );
            }}
          >
            Delete
          </button>
        </td>
      </tr>
    );
  })}
</tbody>
      </table>
    </div>
  </div>
)}

     
      <button
        type="submit"
        className="btn btn-primary text-white px-4 py-2 rounded"
      >
        Save
      </button>
    </form>
  );
}
